
import React from "react";
import { observable, action } from "mobx";
import { observer, inject } from "mobx-react";
//import Button from './forms/inputs/Button';
//import dateFormat from 'dateformat';
//import PostMessageSummary from './PostMessageSummary';
//import TextTruncate from './TextTruncate';
import Swipeout from 'rc-swipeout';
import PostMessageList from "./PostMessageList";
import { IEInput, IETextArea, IEWidgetDateTimePicker, IEReactMultiSelectCluster } from "./InlineEdit/index"

//import Select from 'react-select';

import 'rc-swipeout/dist/rc-swipeout.css';
import '../assets/styles/Post.css'


@inject('postForm')
@inject('postStore')
@inject("clusterStore")
@observer
export default class Post extends React.Component {

    @observable showdetails = false;
    @observable clustervalue = [];

    @action
    showPostDetail() {
        this.showdetails = !this.showdetails;
    }

    @action
    IEChangeState(field, newState) {
        let { postStore, post } = this.props;
        console.log(newState);
        var value = newState.text;
        if (typeof (newState.value) !== 'undefined') {
            value = newState.value;
        }
        if (typeof (value) === 'undefined')
            throw new Error("Error getting new value of component for the post update");

        post[field] = value;
        postStore.updatePost(post);
    }

    @action
    switchPostStatus() {
        let { postStore, post } = this.props;

        if (post.status === 'closed')
            post.status = 'open';
        else post.status = 'closed';

        postStore.updatePost(post, false);
    }

    @action
    deletePost() {
        let { postStore, post } = this.props;
        postStore.deletePost(post);
    }

    @action
    handleSelectChange(newValue) {
        let { post } = this.props;
        post.clusters = newValue;
    }

    render() {
        let { postForm, post, isLoggedIn } = this.props;
        let allowAddUpdate = post.type !== 'information' && post.type !== 'release' && post.status === 'open';
        let swipeDisabled = post.type === 'information' || post.type === 'release';

        return (
            <Swipeout
                disabled={!isLoggedIn || swipeDisabled}
                left={[
                    {
                        text: post.status === 'open' ? 'End' : 'Re-Open',
                        onPress: () => this.switchPostStatus(),
                        className: 'switch-post-status'
                    }
                ]}>
                <div className={"post-content" + (this.showdetails ? " showdetails" : "")}>
                    <div className="post-heading">
                        <div className={"post-status" +
                            (swipeDisabled || post.status === 'closed'
                                ? " post-status-close "
                                : " post-status-open")}></div>
                        <div className={"post-icon icon-" + post.type}/>
                        <div className="post-title">
                            <IEInput
                                value={post.title}
                                change={(newState) => this.IEChangeState('title', newState)}
                                propName="text"
                                validate={(value) => { return postForm.validateField('title', value) }}
                                classEditing="form-field-input"
                                classLoading="loading"
                                classInvalid="invalid" isDisabled={!this.showdetails}/></div>

                        {isLoggedIn &&
                            <div className="post-detail-toggle" onClick={() => this.showPostDetail()}>
                                <div className={"post-detail-toggle " +
                                    (!this.showdetails ? "post-detail-toggle-open" : "post-detail-toggle-closed")}>{
                                        !this.showdetails
                                            ? <img alt="Edit" src={require("../assets/images/edit-button.png")} />
                                        : <img alt="Close" src={require("../assets/images/button-close.svg")} />}</div>
                            </div>}
                    </div>
                    {!this.showdetails && <div className="post-details">
                        <IEReactMultiSelectCluster
                            value={post.clusters}
                            change={(newState) => this.IEChangeState('clusters', newState)}
                            propName="value"
                            classLoading="loading"
                            classInvalid="invalid" isDisabled={!this.showdetails} />
                    </div>}
                    {!this.showdetails &&
                        <div className="post-messages-summary"><PostMessageList items={post.messages} post={post} max={3} isLoggedIn={isLoggedIn} allowAddUpdate={allowAddUpdate} /></div>
                    }

                    {this.showdetails &&
                        <div className="post-details">
                        <button className="post-detail-status-toggle" onClick={() => this.switchPostStatus()}>{post.status === 'open' ? 'End' : 'Re-Open'}</button>
                            <div className="post-detail-description">
                                <IETextArea value={post.description}
                                    change={(newState) => this.IEChangeState('description', newState)}
                                    propName="text"
                                    validate={(value) => { return postForm.validateField('description', value) }}
                                    classEditing="form-field-input"
                                    classLoading="loading"
                                    classInvalid="invalid" isDisabled={!this.showdetails} /></div>
                            <div className="post-detail-clusters">
                                {/* <div id="form-select-clusters--5"
                                         onBlur={this.finishEditing} ref="input">
                                        <Select
                                        options={this.props.clusterStore.ClusterOptions}
                                        onChange={(newvalue) => this.handleSelectChange(newvalue)}
                                            resetValue={[]}
                                            multi={true}
                                            value={post.clusters} //this.props.clusterStore.ClusterOptions.filter(item => post.clusters.includes(item.value))}
                                /></div> */}
                    <IEReactMultiSelectCluster
                        value={post.clusters}
                        change={(newState) => this.IEChangeState('clusters', newState)}
                        propName="value"
                        validate={(value) => { return postForm.validateField('clusters', value) }}
                        classEditing="form-field-input"
                        classLoading="loading"
                        classInvalid="invalid" isDisabled={!this.showdetails}/>
                </div>
                <div className="post-detail-field"><span className="post-detail-header">Expires: </span>
                    <IEWidgetDateTimePicker
                        value={post.expiry}
                        change={(newState) => this.IEChangeState('expiry', newState)}
                        propName="value"
                        validate={(value) => { return postForm.validateField('expiry', value) }}
                        classEditing="form-field-input"
                        classLoading="loading"
                        classInvalid="invalid" isDisabled={!this.showdetails}/>
                </div>
                {<PostMessageList items={post.messages} post={post} isLoggedIn={isLoggedIn} allowAddUpdate={allowAddUpdate} />}
                </div>

                }
                </div>
            </Swipeout>);
    }
}



// WEBPACK FOOTER //
// ./src/components/Post.jsx